const SectionEyebrow = ({ index, label }: { index: string; label: string }) => (
  <div className="flex items-center justify-center gap-3 mb-4" aria-hidden="true">
    <span className="h-px w-8 bg-primary/60" />
    <span className="text-xs font-mono uppercase tracking-[0.3em] text-primary/80">
      {index} // {label}
    </span>
    <span className="h-px w-8 bg-primary/60" />
  </div>
);

export default SectionEyebrow;
